import { LiqpayIcon, MastercardIcon, VisaIcon, WayforpayIcon } from '@/shared/ui/icons';

export const PaymentSystems = [
  {
    name: 'Visa',
    icon: VisaIcon,
  },
  {
    name: 'Mastercard',
    icon: MastercardIcon,
  },
  {
    name: 'Liqpay',
    icon: LiqpayIcon,
  },
  {
    name: 'Wayforpay',
    icon: WayforpayIcon,
  },
];
